import { Box } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Dropdown } from '../Dropdown';
import { DropdownItemsSection } from '../DropdownItemsSection';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon, JobErrorMessage } from '../utils';
import { DOBCaption } from './DOBCaption';
import { DOBRequestDataTableV1 } from './DOBRequestDataTableV1';
import { DOBRequestDataTableV2 } from 'components/account/jobs-v2/dropdowns/DOB/DOBRequestDataTableV2';
import { DobSource } from 'models/jobs/dob';
import { JobExecutionStatus } from 'models/jobs/shared';
export const DOBCompletedResult = ({ parentJobStatus, jobStatus, requestData, dobIsMatch, source }) => {
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: 'DOB Match',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: dobIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !dobIsMatch,
                    hasWarning: false
                }
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [dobIsMatch]);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, jobStatus: jobStatus, parentJobStatus: parentJobStatus }), title: "DOB" },
        React.createElement(Box, null,
            React.createElement(DOBCaption, null),
            jobStatus === JobExecutionStatus.Error ? (React.createElement(JobErrorMessage, { typeName: "DOB verification" })) : (React.createElement(React.Fragment, null,
                React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }),
                requestData &&
                    (source === DobSource.PROVE ? (React.createElement(DOBRequestDataTableV1, { requestData: requestData })) : (React.createElement(DOBRequestDataTableV2, { requestData: requestData }))))))));
};
